import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { HubConnection } from '@microsoft/signalr';
import { Store } from '@ngrx/store';
import { filter, firstValueFrom } from 'rxjs';

import { addLatestNotification } from '@main-application/notifications/actions/notifications.actions';
import { WebNotification } from '@shared/interfaces/notification.interface';
import { AuthService } from '@shared/services/auth.service';
import { SnackbarService } from '@ui-components/components/customized-snackbar/snackbar.service';
import { environment } from 'src/environments/environment';
import { EnvironmentType } from 'src/environments/environment-config';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  hubConnection: HubConnection;

  constructor(private snackbarService: SnackbarService, private auth: AuthService, private store: Store<{}>) {}

  connect(): Promise<void> {
    const tokenPromise = firstValueFrom(this.auth.watchForAccessToken().pipe(filter(Boolean)));

    if (!this.hubConnection) {
      this.hubConnection = new signalR.HubConnectionBuilder()
        .configureLogging(
          environment.type === EnvironmentType.Prod ? signalR.LogLevel.Critical : signalR.LogLevel.Information
        )

        .withUrl(environment.notificationsAllUrl, {
          transport: signalR.HttpTransportType.WebSockets,
          skipNegotiation: true,
          accessTokenFactory: () => tokenPromise,
        })
        .withAutomaticReconnect()
        .build();

      this.hubConnection.on('Notify', (notification: WebNotification) => {
        this.distributeNotifications(notification);
      });
    }

    return this.hubConnection.start().catch(err => {
      return err;
    });
  }

  close() {
    if (this.hubConnection) {
      this.hubConnection.stop().then();
    }
  }

  private distributeNotifications(notification: WebNotification) {
    this.store.dispatch(addLatestNotification({ notification }));
  }
}
